/**
 * Error de una llamada al servidor, sea cual sea el servidor.
 *
 * Vive aparte del cliente de Directus porque el nucleo del editor (los hooks de
 * autoguardado y sugerencias) lo usa para decidir que mostrar, y ese nucleo
 * tambien corre dentro de la suite de personas, que no habla con Directus.
 *
 * `status` 0 significa que no hubo respuesta: sin conexion o servidor caido. Se
 * distingue de un 4xx/5xx porque la interfaz reacciona distinto -- reintentar
 * tiene sentido aqui y no cuando el servidor ya dijo que no.
 */
export class ErrorApi extends Error {
  constructor(
    readonly status: number,
    mensaje: string,
    readonly cuerpo?: unknown,
  ) {
    super(mensaje);
    this.name = "ErrorApi";
  }
}
